import { GlobalAlertSuccess } from '../../actionTypes/globalAlertActions';

const inititalState = {
  globalAlert: [],
};

export const globalAlertReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GlobalAlertSuccess:
      return {
        ...state,
        globalAlert: payload,
      };
    default:
      return state;
  }
};
